import { useState } from 'react';
import axios from 'axios';
import './PublicSite.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    type: 'general'
  });
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      await axios.post(`${API}/public/contact`, formData);
      setStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '', type: 'general' });
    } catch (error) {
      console.error('Contact form error:', error);
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page contact-page">
      <section className="page-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p className="lead">We'd love to hear from you</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Get In Touch</h2>
              <p>
                Whether you're a rescue organization, potential sponsor, media inquiry, or just someone who believes in our mission—we want to connect.
              </p>

              <div className="contact-methods">
                <div className="contact-method">
                  <h3>📧 Email</h3>
                  <p><a href="mailto:sabbathpreservationmovement@gmail.com">sabbathpreservationmovement@gmail.com</a></p>
                </div>

                <div className="contact-method">
                  <h3>📍 Location</h3>
                  <p>
                    <strong>Registered Address:</strong><br/>
                    5481 Caves Hwy<br/>
                    Cave Junction, OR 97523
                  </p>
                  <p>
                    <strong>Operating Site:</strong><br/>
                    Off-grid sanctuary in Beatty, Oregon<br/>
                    Coordinates: 42.512400, -121.356900
                  </p>
                </div>

                <div className="contact-method">
                  <h3>🌐 501(c)(3) Nonprofit</h3>
                  <p>Sabbath Preservation Movement is a registered 501(c)(3) nonprofit organization. All donations are tax-deductible.</p>
                </div>
              </div>
            </div>

            <div className="contact-form-container">
              <h2>Send Us a Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Name *</label>
                  <input
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={(e) => setFormData({...formData, name: e.target.value})}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="type">I'm interested in... *</label>
                  <select
                    id="type"
                    value={formData.type}
                    onChange={(e) => setFormData({...formData, type: e.target.value})}
                    required
                  >
                    <option value="general">General Inquiry</option>
                    <option value="donation">Making a Donation</option>
                    <option value="sponsorship">Sponsorship Opportunities</option>
                    <option value="partnership">Partnership/Collaboration</option>
                    <option value="rescue">Rescue Organization Partnership</option>
                    <option value="media">Media Inquiry</option>
                    <option value="volunteer">Volunteering (Future)</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <input
                    type="text"
                    id="subject"
                    value={formData.subject}
                    onChange={(e) => setFormData({...formData, subject: e.target.value})}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    rows="6"
                    value={formData.message}
                    onChange={(e) => setFormData({...formData, message: e.target.value})}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Sending...' : 'Send Message'}
                </button>

                {status === 'success' && (
                  <div className="form-message success">
                    ✅ Thank you! We've received your message and will respond soon.
                  </div>
                )}

                {status === 'error' && (
                  <div className="form-message error">
                    ❌ Something went wrong. Please email us directly at sabbathpreservationmovement@gmail.com
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}